import {
    CreateImageMutation,
    CreateImageMutationVariables,
    DeleteImageMutation,
    DeleteImageMutationVariables
} from 'generated/graphql'
import gql from 'graphql-tag'
import graphql from 'utils/graphql'

const createImageMutation = gql`
    mutation createImage($data: CreateImage!) {
        createImage(data: $data) {
            id
            file
        }
    }    
`
export const createImage = (organizationId, file) => graphql.createQuery<
    CreateImageMutation, CreateImageMutationVariables
>(createImageMutation)({ data: { organizationId, file } })

const deleteImageMutation = gql`
    mutation deleteImage($id: ID!) {
        deleteImage(id: $id)
    }
`
export const deleteImage = (id) => graphql.createQuery<
    DeleteImageMutation, DeleteImageMutationVariables
>(deleteImageMutation)({ id })
